import { Injectable } from "@angular/core";
@Injectable()
export class GroupModel{
    Group: String;
    Description: String;
}